import Slider from "@mui/material/Slider";
import "./YearSlider.css";
import { Chip, Label } from "@digdir/designsystemet-react";
import { FlexContainer } from "../../shared/FlexContainer";

type YearSliderProps = {
    minYear: number | null;
    maxYear: number | null;
    fromYear: number | null;
    toYear: number | null;
    onChange: (nextRange: { fromYear: number; toYear: number }) => void;
};

export function YearSlider({ minYear, maxYear, fromYear, toYear, onChange }: YearSliderProps) {
    const isDisabled = minYear === null || maxYear === null || fromYear === null || toYear === null;
    const shouldShowResetButton = !isDisabled && (fromYear !== minYear || toYear !== maxYear);
    const safeFromYear = fromYear ?? 0;
    const safeToYear = toYear ?? 0;
    const marks =
        minYear !== null && maxYear !== null
            ? Array.from({ length: maxYear - minYear + 1 }, (_, index) => {
                  const year = minYear + index;
                  return { value: year, label: year };
              })
            : [];

    return (
        <section className="prosjektliste-year-slider-filter" aria-label="Vedtaksår">
            <div className="year-slider" data-disabled={isDisabled ? "true" : "false"}>
                <FlexContainer justifyContent="space-between" alignItems="center">
                    <Label htmlFor="year-slider" className="year-slider-label">
                        Vedtaksår
                    </Label>
                    {shouldShowResetButton && (
                        <Chip.Button
                            onClick={() => onChange({ fromYear: minYear ?? 0, toYear: maxYear ?? 0 })}
                            style={{ marginBottom: "-0.5rem" }}
                        >
                            Nullstill vedtaksår
                        </Chip.Button>
                    )}
                </FlexContainer>
                <Slider
                    id="year-slider"
                    disableSwap
                    value={[safeFromYear, safeToYear]}
                    min={minYear ?? 0}
                    max={maxYear ?? 0}
                    step={1}
                    marks={marks}
                    disabled={isDisabled}
                    aria-labelledby="year-slider"
                    getAriaLabel={(index) => (index === 0 ? "Fra år" : "Til år")}
                    valueLabelDisplay="auto"
                    onChange={(_, value) => {
                        if (!Array.isArray(value) || value.length !== 2) {
                            return;
                        }

                        onChange({
                            fromYear: value[0],
                            toYear: value[1],
                        });
                    }}
                />
            </div>
        </section>
    );
}
